import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Volunteering.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function Volunteering() {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);

  // Handler functions
  const handleJoinUs = () => {
    navigate('/community');
  };

  const handleLearnMore = () => {
    const benefitsSection = document.querySelector('.volunteer-why-choose-section');
    if (benefitsSection) {
      benefitsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleGetStarted = () => {
    navigate('/community');
  };

  // Create floating particles
  useEffect(() => {
    const createParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 20; i++) {
        newParticles.push({
          id: i,
          left: Math.random() * 100,
          animationDelay: Math.random() * 6,
          duration: 4 + Math.random() * 4
        });
      }
      setParticles(newParticles);
    };

    createParticles();
  }, []);

  // Scroll animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('.volunteer-why-choose-section, .volunteer-community-section, .volunteer-how-it-works-section');
    sections.forEach(section => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="volunteer-page page-with-header">
      {/* Floating Particles */}
      <div className="volunteer-floating-particles">
        {particles.map(particle => (
          <div
            key={particle.id}
            className="volunteer-particle"
            style={{
              left: `${particle.left}%`,
              animationDelay: `${particle.animationDelay}s`,
              animationDuration: `${particle.duration}s`
            }}
          />
        ))}
      </div>
      
      <Header />
      
      {/* Hero Section */}
      <section className="volunteer-hero">
        <div className="volunteer-hero-content">
          <div className="volunteer-hero-text">
            <h1 className="volunteer-hero-title">Tình nguyện - Cùng nhau tạo nên sự khác biệt</h1>
            <p className="volunteer-hero-subtitle">
              Tham gia vào cộng đồng tình nguyện của chúng tôi và góp phần hỗ trợ những người đang cần sự giúp đỡ. 
              Cùng nhau, chúng ta có thể tạo nên những thay đổi tích cực trong cuộc sống.
            </p>
            <button className="volunteer-hero-cta-btn" onClick={handleJoinUs}>Tham gia ngay</button>
          </div>
          <div className="volunteer-hero-visual">
            <div className="volunteer-computer-icon">
              <div className="volunteer-monitor-screen">🤝</div>
              <div className="volunteer-monitor-base"></div>
              <div className="volunteer-headphones-left">❤️</div>
              <div className="volunteer-headphones-right">💙</div>
            </div>
          </div>
        </div>
      </section>

      {/* Training Section */}
      <section className="volunteer-training-section">
        <div className="volunteer-training-content">
          <div className="volunteer-training-text">
            <h2 className="volunteer-training-title">Đào tạo và Phát triển</h2>
            <p className="volunteer-training-description">
              Chúng tôi cung cấp các khóa đào tạo chuyên nghiệp để giúp bạn trở thành một tình nguyện viên hiệu quả. 
              Từ kỹ năng lắng nghe đến hỗ trợ tâm lý, bạn sẽ được trang bị đầy đủ kiến thức cần thiết.
            </p>
            <div className="volunteer-training-buttons">
              <button className="volunteer-learn-more-btn" onClick={handleLearnMore}>Tìm hiểu thêm</button>
              <button className="volunteer-get-started-btn" onClick={handleGetStarted}>Bắt đầu</button>
            </div>
          </div>
          <div className="volunteer-training-video">
            {/* Mac Browser Wrapper for Video */}
            <div className="volunteer-mac-browser">
              <div className="volunteer-browser-header">
                <div className="volunteer-browser-controls">
                  <div className="volunteer-browser-btn volunteer-close-btn"></div>
                  <div className="volunteer-browser-btn volunteer-minimize-btn"></div>
                  <div className="volunteer-browser-btn volunteer-maximize-btn"></div>
                </div>
                <div className="volunteer-browser-url">
                  <div className="volunteer-url-icon">🔒</div>
                  <span>https://learntomend.com/volunteer</span>
                </div>
                <div className="volunteer-browser-menu">
                  <div className="volunteer-menu-btn">⋮</div>
                </div>
              </div>
              <div className="volunteer-browser-content">
                <div className="volunteer-video-container">
                  <img 
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=500&h=400&fit=crop" 
                    alt="Volunteer training" 
                    className="volunteer-video-preview"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="volunteer-why-choose-section">
        <div className="volunteer-why-choose-content">
          <div className="volunteer-why-choose-text">
            <h2 className="volunteer-why-choose-title">Tại sao nên tham gia?</h2>
            <p className="volunteer-why-choose-subtitle">Tham gia tình nguyện mang lại nhiều lợi ích:</p>
            <button className="volunteer-start-listening-btn" onClick={handleJoinUs}>Tham gia ngay</button>
          </div>
          <div className="volunteer-benefits-list">
            <div className="volunteer-benefit-item">
              <div className="volunteer-benefit-icon">🤝</div>
              <div className="volunteer-benefit-content">
                <h3 className="volunteer-benefit-title">Giúp đỡ người khác</h3>
                <p className="volunteer-benefit-description">Góp phần hỗ trợ những người đang gặp khó khăn về tâm lý và tinh thần.</p>
              </div>
            </div>
            <div className="volunteer-benefit-item">
              <div className="volunteer-benefit-icon">📚</div>
              <div className="volunteer-benefit-content">
                <h3 className="volunteer-benefit-title">Phát triển kỹ năng</h3>
                <p className="volunteer-benefit-description">Học hỏi và phát triển các kỹ năng giao tiếp, lắng nghe và hỗ trợ tâm lý.</p>
              </div>
            </div>
            <div className="volunteer-benefit-item">
              <div className="volunteer-benefit-icon">🌟</div>
              <div className="volunteer-benefit-content">
                <h3 className="volunteer-benefit-title">Xây dựng cộng đồng</h3>
                <p className="volunteer-benefit-description">Tham gia vào một cộng đồng tích cực, hỗ trợ lẫn nhau và cùng phát triển.</p>
              </div>
            </div>
            <div className="volunteer-benefit-item">
              <div className="volunteer-benefit-icon">💪</div>
              <div className="volunteer-benefit-content">
                <h3 className="volunteer-benefit-title">Tăng cường sức khỏe tinh thần</h3>
                <p className="volunteer-benefit-description">Giúp đỡ người khác cũng là cách để cải thiện sức khỏe tinh thần của chính bạn.</p>
              </div>
            </div>
            <div className="volunteer-benefit-item">
              <div className="volunteer-benefit-icon">🎯</div>
              <div className="volunteer-benefit-content">
                <h3 className="volunteer-benefit-title">Tạo ý nghĩa cuộc sống</h3>
                <p className="volunteer-benefit-description">Tìm thấy mục đích và ý nghĩa trong việc đóng góp cho cộng đồng.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="volunteer-community-section">
        <div className="volunteer-community-content">
          <div className="volunteer-community-visual">
            <div className="volunteer-community-placeholder">👥</div>
          </div>
          <div className="volunteer-community-text">
            <h2 className="volunteer-community-title">Tham gia cộng đồng tình nguyện</h2>
            <p className="volunteer-community-description">Kết nối với những tình nguyện viên khác, chia sẻ kinh nghiệm và cùng nhau tạo nên những thay đổi tích cực. 
            Tham gia các hoạt động tình nguyện và góp phần xây dựng một cộng đồng hỗ trợ lẫn nhau.</p>
            <button className="volunteer-join-us-btn" onClick={handleJoinUs}>Tham gia ngay</button>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="volunteer-how-it-works-section">
        <div className="volunteer-how-it-works-content">
          <h2 className="volunteer-how-it-works-title">Cách tham gia</h2>
          <p className="volunteer-how-it-works-subtitle">Bắt đầu hành trình tình nguyện của bạn chỉ trong vài bước đơn giản</p>
          <div className="volunteer-steps-grid">
            <div className="volunteer-step-item">
              <div className="volunteer-step-placeholder">📝</div>
              <div className="volunteer-step-content">
                <h3 className="volunteer-step-title">Bước 1: Đăng ký</h3>
                <p className="volunteer-step-description">Điền form đăng ký và cung cấp thông tin cơ bản về bản thân.</p>
              </div>
            </div>
            <div className="volunteer-step-item">
              <div className="volunteer-step-placeholder">🎓</div>
              <div className="volunteer-step-content">
                <h3 className="volunteer-step-title">Bước 2: Tham gia đào tạo</h3>
                <p className="volunteer-step-description">Hoàn thành các khóa đào tạo cơ bản về kỹ năng hỗ trợ tâm lý.</p>
              </div>
            </div>
            <div className="volunteer-step-item">
              <div className="volunteer-step-placeholder">🤝</div>
              <div className="volunteer-step-content">
                <h3 className="volunteer-step-title">Bước 3: Bắt đầu tình nguyện</h3>
                <p className="volunteer-step-description">Tham gia các hoạt động tình nguyện và hỗ trợ những người cần giúp đỡ.</p>
              </div>
            </div>
            <div className="volunteer-step-item">
              <div className="volunteer-step-placeholder">✨</div>
              <div className="volunteer-step-content">
                <h3 className="volunteer-step-title">Bước 4: Phát triển và đóng góp</h3>
                <p className="volunteer-step-description">Tiếp tục học hỏi, phát triển kỹ năng và đóng góp cho cộng đồng.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
